module.exports = __webpack_public_path__ + "img/mediaPause.6880937b.svg";